import { render, staticRenderFns } from "./alarmMessage.vue?vue&type=template&id=f754e4f2&scoped=true&"
import script from "./alarmMessage.vue?vue&type=script&lang=js&"
export * from "./alarmMessage.vue?vue&type=script&lang=js&"
import style0 from "./alarmMessage.vue?vue&type=style&index=0&id=f754e4f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f754e4f2",
  null
  
)

export default component.exports